// Translation: Account > Billing > Statistics (English)
export default Object.freeze({
	cards: {
		endOfThisMonth: {
			fields: {
				balance: 'Balance',
				expenses: 'Expenses',
				revenue: 'Revenue'
			},
			title: 'End of this month (Forecast)'
		},
		lastMonth: {
			fields: {
				balance: 'Balance',
				expenses: 'Expenses',
				revenue: 'Revenue'
			},
			title: 'Last month'
		},
		monthToDate: {
			fields: {
				balance: 'Balance',
				expenses: 'Expenses',
				revenue: 'Revenue'
			},
			title: 'Month-to-date'
		}
	},
	fallback: {
		unavailable: 'Information is not available.'
	},
	title: 'Usage statistics'
})
